
export const CORREO_MONITOREO = "monitoreo@coordinarseguridad.com";

export const CORREO_SISTEMAS = "sistemas@coordinarseguridad.com";

export const CORREOS_SOS = [CORREO_SISTEMAS, CORREO_MONITOREO];

export const normalizarCorreo = (correo) =>
  String(correo ?? "").trim().toLowerCase();

export const puedeVerSOS = (correo) =>
  CORREOS_SOS.includes(normalizarCorreo(correo));

export const correoSesion = () => {
  try {
    return normalizarCorreo(localStorage.getItem("CorreoElectronico"));
  } catch {
    return "";
  }
};
